module.exports = __webpack_public_path__ + "static/img/icon-switch-kwai.8eec722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toutiao/icon-switch-kwai.png
// module id = RVKt
// module chunks = 156